import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

const initialState: unknown[] = [];

const errorsSlice = createSlice({
  name: "errors",
  initialState,
  reducers: {
    setErrors: (state, action: PayloadAction<unknown>) => {
      state.push(action.payload);
    },
  },
});

export const { setErrors } = errorsSlice.actions;
export default errorsSlice.reducer;
